"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var count = 0;
var _default = exports["default"] = function _default() {
  return 'cccisd-tinymce-' + count++;
};